// extracted by mini-css-extract-plugin
export default {"button":"PartnerNumberAlert_button__74mSM","container":"PartnerNumberAlert_container__4qI6x","actionsWrapper":"PartnerNumberAlert_actionsWrapper__3f9LL"};